import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar, Alert } from "@mui/material";

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = useCallback((message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      <Snackbar
        open={snackbar.open}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={3000}
        onClose={handleClose}
      // Optional: Adds a slight fade-in animation constraint if needed
      >
        <Alert
          severity={snackbar.severity}
          variant="filled" // Changes the alert from light outline to solid background
          onClose={handleClose}
          sx={{
            width: "100%",
            minWidth: "300px",
            borderRadius: "12px",
            fontSize: "0.95rem",
            fontWeight: 500,
            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
            alignItems: "center", // Perfectly centers icons and text vertically

            // Target specific statuses to override default MUI colors
            '&.MuiAlert-filledSuccess': {
              backgroundColor: '#10b981', // Emerald green
            },
            '&.MuiAlert-filledError': {
              backgroundColor: '#ef4444', // Vibrant red
            },
            '&.MuiAlert-filledWarning': {
              backgroundColor: '#f59e0b', // Amber yellow
            },
            '&.MuiAlert-filledInfo': {
              backgroundColor: '#3b82f6', // Bright blue
            },
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>


    </SnackbarContext.Provider>
  );
};